module.exports = __webpack_public_path__ + "media/images/hamburguer-ad59877f760ebc26e9a750c8188b5f71.svg";